export enum ConfigCategory {
  public = "public",
  account = "account",
  party = "party",
}
